import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Briefcase } from 'lucide-react';
import { Button } from '../ui/Button';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'How It Works',
    href: '/how-it-works'
  }, {
    name: 'Employers',
    href: '/employers'
  }, {
    name: 'Blog',
    href: '/blog'
  }];
  return <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-68" data-mp="332glej9iitm4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69" data-mp="37n5ng0s685xk">
        <div className="flex justify-between items-center" data-id="element-70" data-mp="37lkrc6q7kexl">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-5 mr-12" data-id="element-71" data-mp="32mrdgd70elww">
            {/* Circular Emblem */}
            <div className="relative flex-shrink-0" data-id="element-72" data-mp="2xp9ftiyfzt47">
              {/* Outermost ring */}
              <div className={`w-16 h-16 rounded-full flex items-center justify-center transition-all duration-300 ${scrolled ? 'bg-navy-900 shadow-lg shadow-navy-900/30' : 'bg-white/15 backdrop-blur-md shadow-lg shadow-black/20'}`} data-id="element-73" data-mp="2srzfh89ilx1l">
                {/* Middle decorative ring */}
                <div className={`absolute w-14 h-14 rounded-full border transition-all duration-300 ${scrolled ? 'border-gold-500/60' : 'border-white/40'}`} data-id="element-74" data-mp="2ewx1ryyff3e8" />
                {/* Inner ring */}
                <div className={`absolute w-11 h-11 rounded-full border transition-all duration-300 ${scrolled ? 'border-gold-500/30' : 'border-white/20'}`} data-id="element-75" data-mp="1vd81a0m6mdnl" />
                {/* Center content */}
                <div className="relative z-10 flex flex-col items-center justify-center" data-id="element-76" data-mp="1mdl8223lwe5m">
                  <span className={`text-sm font-serif font-bold leading-none tracking-tight transition-colors duration-300 ${scrolled ? 'text-gold-500' : 'text-white'}`} data-id="element-77" data-mp="1qdd8friujdzw">
                    CTS
                  </span>
                  <div className={`w-5 h-px mt-0.5 transition-colors duration-300 ${scrolled ? 'bg-gold-500/60' : 'bg-white/50'}`} data-id="element-78" data-mp="2j4n37sa1qsyb" />
                </div>
              </div>
            </div>

            {/* Brand Name */}
            <div className="flex flex-col leading-none" data-id="element-79" data-mp="2x1s8vr5ulpt1">
              <span className={`text-xl font-serif font-bold tracking-wide transition-colors duration-300 ${scrolled ? 'text-navy-900' : 'text-white'}`} data-id="element-80" data-mp="31t1w6l3xch1r">
                Continuum
              </span>
              <span className={`text-xs font-medium tracking-[0.12em] uppercase mt-0.5 transition-colors duration-300 ${scrolled ? 'text-gold-500' : 'text-white/70'}`} data-id="element-81" data-mp="le6s1d75y6qo">
                Talent Solutions
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-82" data-mp="7fz0jkswbxmw">
            {navLinks.map(link => <Link key={link.name} to={link.href} className={`text-sm font-medium transition-colors hover:text-gold-500 ${scrolled ? 'text-gray-700' : 'text-white/90'}`} data-id="element-83" data-mp="2i6y3wumkt4g">
                {link.name}
              </Link>)}
            <Button variant="gold" size="sm" href="/contact" data-id="element-84" data-mp="1sqyw0cqyt7n0">
              Book Consultation
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-85" data-mp="3tj120ixcn4z1">
            <button onClick={() => setIsOpen(!isOpen)} className={`p-2 rounded-md ${scrolled ? 'text-navy-900' : 'text-white'}`} data-id="element-86" data-mp="3tk2dupm6vvht">
              {isOpen ? <X className="h-6 w-6" data-id="element-87" data-mp="6fe5wjdxmqze" /> : <Menu className="h-6 w-6" data-id="element-88" data-mp="bdfkar0ey24j" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-white border-t absolute w-full shadow-lg" data-id="element-89" data-mp="laajlc4ig6jv">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-90" data-mp="l87ls5x4994l">
            {navLinks.map(link => <Link key={link.name} to={link.href} className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-navy-900 hover:bg-gray-50 rounded-md" data-id="element-91" data-mp="q3mvclo3civ7">
                {link.name}
              </Link>)}
            <div className="pt-4" data-id="element-92" data-mp="13yxn3q71gnvc">
              <Button variant="gold" fullWidth href="/contact" data-id="element-93" data-mp="1e4p2g76xkqkg">
                Book Consultation
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}